import { render, staticRenderFns } from "./LoginToken.vue?vue&type=template&id=d317e06c&scoped=true"
import script from "./LoginToken.vue?vue&type=script&lang=js"
export * from "./LoginToken.vue?vue&type=script&lang=js"
import style0 from "./LoginToken.vue?vue&type=style&index=0&id=d317e06c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d317e06c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d317e06c')) {
      api.createRecord('d317e06c', component.options)
    } else {
      api.reload('d317e06c', component.options)
    }
    module.hot.accept("./LoginToken.vue?vue&type=template&id=d317e06c&scoped=true", function () {
      api.rerender('d317e06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/LoginToken.vue"
export default component.exports